import { render, staticRenderFns } from "./PartnerDialog.vue?vue&type=template&id=dd8d8eec"
import script from "./PartnerDialog.vue?vue&type=script&lang=js"
export * from "./PartnerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports